import React, { useState } from 'react';
import styled from 'styled-components';

import MaterialSymbol from '#/components/basic/icons/MaterialSymbol';
import Link from '#/components/basic/Link/Link';
import { useSelector } from '#/reduxState/store';

const InnerFlex = styled.span`
  height: 100%;
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  gap: 4px;
  color: var(--white);
`;

export default function DownloadCsvButton({
  title,
  titleAsLink,
  getDownloadUrl,
  disabled,
}: {
  title: string;
  titleAsLink?: boolean;
  getDownloadUrl: (wallet: string) => string;
  disabled?: boolean;
}) {
  const walletAddress = useSelector(state => state.wallet.walletAddress);

  const [downloaded, setDownloaded] = useState(false);

  return (
    <Link
      href={getDownloadUrl(walletAddress) || '#'}
      onClick={event => {
        if (disabled || downloaded) {
          event.preventDefault();
          return;
        }
        setDownloaded(true);
      }}
      disabled={disabled || !walletAddress || downloaded}
      target="_blank"
    >
      <InnerFlex>
        {downloaded ? (
          <>
            {title} downloaded <MaterialSymbol icon="check" fontSize="small" />
          </>
        ) : (
          <>
            {titleAsLink ? title : 'Download CSV'}{' '}
            <MaterialSymbol icon="download" fontSize="small" />
          </>
        )}
      </InnerFlex>
    </Link>
  );

  // Button way:
  // const Button = styled.span<{ disabled: boolean }>`
  //   cursor: pointer;
  //   display: inline-flex;
  //   align-items: center;
  //   color: var(--primary3);
  //   white-space: nowrap;
  //   overflow: hidden;

  //   &:hover {
  //     color: var(--primary4);
  //   }

  //   ${({ disabled }) =>
  //     disabled
  //       ? `
  //     color: var(--gray3) !important;
  //     cursor: not-allowed;
  //   `
  //       : ''}
  // `;
  // return (
  //   <div style={{ display: 'flex' }}>
  //     <Button
  //       disabled={!walletAddress}
  //       onClick={
  //         downloaded || !walletAddress
  //           ? undefined
  //           : () => {
  //               setDownloaded(true);
  //               onDownload(walletAddress);
  //             }
  //       }
  //     >
  //       {downloaded ? (
  //         <>
  //           {title} downloaded <CheckIcon fontSize="small" />
  //         </>
  //       ) : (
  //         <>
  //           Download CSV <DownloadIcon fontSize="small" />
  //         </>
  //       )}
  //     </Button>
  //   </div>
  // );
}
